import type { ReactElement } from 'react'
import { CloudUpload, TriangleAlert } from 'lucide-react'
import { Button, Modal } from '@/components/ui'
import { formatNumber, pluralize } from '@/lib/format'

export interface SaveConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  /** Approved-and-unsaved images — exactly what the job will write. */
  count: number
  installName: string
  saving?: boolean
}

export function SaveConfirmDialog({
  open,
  onClose,
  onConfirm,
  count,
  installName,
  saving = false
}: SaveConfirmDialogProps): ReactElement {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Save alt tags"
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button data-autofocus iconLeft={<CloudUpload />} onClick={onConfirm} loading={saving}>
            Confirm save
          </Button>
        </>
      }
    >
      <p className="text-sm leading-relaxed text-fg-muted">
        This will update{' '}
        <strong className="font-semibold text-fg">
          {formatNumber(count)} alt {pluralize(count, 'tag')}
        </strong>{' '}
        on <strong className="font-semibold text-fg">{installName}</strong> via SSH.
      </p>

      <div className="mt-4 flex items-start gap-3 rounded-card border border-warn-500/35 bg-warn-100/60 p-3 dark:bg-warn-950/50">
        <TriangleAlert
          className="mt-px size-4 shrink-0 text-warn-700 dark:text-warn-300"
          aria-hidden="true"
        />
        <p className="text-xs leading-relaxed text-fg-muted">
          Alt text is written straight to the live WordPress media library and replaces whatever is
          there now. Only approved images that have not been saved yet are included.
        </p>
      </div>
    </Modal>
  )
}
